// ActionItem.tsx (MUI)

import React, { ComponentType } from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

type ActionItemProps = {
  icon: ComponentType<{ size?: number; color?: string }>;
  label: string;
  sublabel: string;
  color?: "active" | "primary" | "default" | string;
  onPress: () => void;
  big: boolean;
};

export function ActionItem({ icon: Icon, label, sublabel = "", big = false, color = "default", onPress }: ActionItemProps) {
  const theme = useTheme();

  // Rough equivalent of theme.color10.get()
  const iconColor = theme.palette.text.secondary;

  const resolveBackground = () => {
    if (color === "blue") return "#b4c7f0"; // Light Blue
    if (color === "green") return "#9afa9aff"; // Light Green
    if (color === "orange") return "#ffe4adff"; // Light Orange
    if (color === "pink") return "#fec3ccff"; // Light Pink

    if (color === "default") return "#eee";
    return color;
  };

  return (
    <Box
      onClick={onPress}
      sx={{
        cursor: "pointer",
        p: 2,
        pb: 1,
        minWidth: big ? 120 : 70,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 0.5,
        borderRadius: 1,
        border: "1px solid",
        borderColor: theme.palette.divider,
        backgroundColor: resolveBackground(),
        "&:hover": {
          opacity: 0.8,
        },
        "&:active": {
          opacity: 0.8,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {Icon ? <Icon size={big ? 30 : 22} color={iconColor} /> : null}
      </Box>

      <Typography
        sx={{
          lineHeight: 1.2,
          fontSize: big ? 18 : 14,
          color: theme.palette.text.primary,
        }}
      >
        {label}
      </Typography>

      {sublabel.length > 0 ? (
        <Typography
          sx={{
            lineHeight: 1.2,
            fontSize: big ? 14 : 12,
            color: theme.palette.text.secondary,
          }}
        >
          {sublabel}
        </Typography>
      ) : null}
    </Box>
  );
}
